<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12" lg="3" sm="6">
            <div v-if="formType !== 'admission' && formType !== 'createAdmission'">
              <span class="body-2 font-weight-medium">Select Franchisee</span>
              <span class="error--text ml-1">*</span>
              <v-autocomplete
                name="selectFranchisee"
                :disabled="formType==='createEnquiryQR'"
                required
                v-model="value.franchiseeID"
                key="id"
                class="my-0 py-1"
                single-line
                placeholder="---Select---"
                :items="franchiseeArr"
                item-text="companyName"
                item-value="id"
              >
              </v-autocomplete>
            </div>
            <div v-if="formType === 'admission' || formType === 'createAdmission' || formType === 'edit_registration'">
              <span class="body-2 font-weight-medium">Franchisee</span>
              <span class="error--text ml-1">*</span>
              <v-text-field type="text" placeholder="Franchisee Name" class="my-0 py-1" v-model="value.franchiseeName" readonly disabled single-line> </v-text-field>
            </div>
          </v-col>
          <v-col cols="12" lg="3" sm="6" v-if="formType !== 'admission' && formType !== 'createAdmission'">
            <span class="body-2 font-weight-medium"> Academic Year</span>
            <span class="error--text ml-1">*</span>
            <v-autocomplete required v-model="value.academicYearID" key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="4" sm="6" v-if="formType === 'admission' || formType === 'createAdmission'">
            <span class="body-2 font-weight-medium">Academic Year</span>
            <span class="error--text ml-1">*</span>
            <v-text-field type="text" placeholder="Academic Year Name" class="my-0 py-1" single-line v-model="value.academicYrName" readonly disabled> </v-text-field>
          </v-col>

          <v-col cols="12" lg="3" sm="6" v-if="showAdmissionDate !== 'false' && formType === 'admission' && value.dateOfAdmission">
            <span class="body-2 font-weight-medium">Date Of Admission</span>
            <span class="error--text ml-1">*</span>
            <v-text-field type="text" placeholder="Date of Admission" class="my-0 py-1" single-line v-model="value.dateOfAdmission" readonly disabled> </v-text-field>
          </v-col>

          <v-col cols="12" lg="3" sm="6" v-if="showAdmissionDate !== 'false' && formType === 'admission' && !value.dateOfAdmission">
            <span class="body-2 font-weight-medium">Date Of Admission</span>
            <span class="error--text ml-1">*</span>
            <v-datetime-picker v-model="value.admissionDateTime" :maxToDate="maxToDate" />
          </v-col>

          <v-col cols="12" lg="3" sm="6" v-if="formType !== 'admission' && formType !== 'createAdmission' && formType !== 'registration' && value.dateOfEnquiry && formType !== 'createEnquiryQR'">
            <span class="body-2 font-weight-medium">Date Of Enquiry</span>
            <span class="error--text ml-1">*</span>
            <v-text-field readonly disabled class="my-0 py-1" single-line v-model="value.dateOfEnquiry"> </v-text-field>
          </v-col>

          <v-col cols="12" lg="3" sm="6" v-if="formType !== 'admission' && formType !== 'createAdmission' && !value.dateOfEnquiry && formType !== 'createEnquiryQR'">
            <span class="body-2 font-weight-medium">Date Of Enquiry</span>
            <span class="error--text ml-1">*</span>
            <v-datetime-picker class="my-0 py-1" v-model="selectEnquiryDate" :maxToDate="maxToDate" />
          </v-col>
          <v-col cols="12" lg="6" sm="6" v-if="formType !== 'admission' && formType !== 'createAdmission'">
            <span class="body-2 font-weight-medium">Opting Class</span>
            <span class="error--text ml-1">*</span>
            <v-autocomplete
              v-model="value.classID"
              key="id"
              class="my-0 py-1"
              required
              @change="getSections()"
              single-line
              placeholder="---Select---"
              :items="classes"
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" lg="4" sm="6" v-if="formType === 'admission' || formType === 'createAdmission'">
            <span class="body-2 font-weight-medium">Class</span>
            <span class="error--text ml-1">*</span>
            <v-text-field type="text" readonly disabled placeholder="Class" class="my-0 py-1" single-line v-model="value.className"> </v-text-field>
          </v-col>

          <v-col cols="12" lg="4" sm="6" v-if="formType === 'admission' || formType === 'createAdmission'">
            <span class="body-2 font-weight-medium">Section</span>
            <span class="error--text ml-1">*</span>
            <v-text-field type="text" placeholder="" class="my-0 py-1" single-line v-model="value.sectionName" readonly disabled> </v-text-field>
          </v-col>

          <v-col cols="12" lg="4" sm="6" v-if="formType === 'admission'">
            <span class="body-2 font-weight-medium">Section</span>
            <span class="error--text ml-1">*</span>
            <v-autocomplete v-model="value.sectionID" required key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="sectionData" item-text="name" item-value="id">
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import Utils from '@/utils'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'AdmissionElement',
  // props: ['stuData'],
  props: {
    value: {
      default: () => {},
      type: Object
    },
    formType: {
      default: '',
      type: String
    },
    showAdmissionDate: {
      default: '',
      type: String
    }
  },
  components: {
    VCardComponent
  },
  data: function () {
    return {
      academicYears: [],
      loadingComponent: null,
      isWrite: false,
      isEnquiry: false,
      franchiseeArr: [],
      classes: [],
      cardTitle: '',
      cardIcon: '',
      maxToDate: moment().format('YYYY-MM-DD HH-mm-ss'),
      selectEnquiryDate: new Date(),
      franchiseeName: '',
      sectionData: [],
      obj: {
        franchiseeID: '',
        academicYearID: '',
        dateOfEnquiry: '',
        classID: ''
      },
      filter: {
        academicYearID: ''
      }
    }
  },

  async created () {
    await this.customCreate()
    await this.writableData()
    if (this.formType === 'edit_registration' || this.formType === 'admission') {
      await this.getSections()
    }

    if (this.formType === 'enquiry') {
      this.isEnquiry = true
    }
  },
  watch: {
    selectEnquiryDate: async function (dtObj) {
      this.value.enquiryDateTime = dtObj
    }
  },
  methods: {
    getSections: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.formType === 'edit_registration' || this.formType === 'admission') {
          const { data } = await http.get(`${constants.API_URL}/api/students/section/${this.value.classID}`)
          this.sectionData = data.studentSections
        }

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      }
    },
    customCreate: async function () {
      this.value.enquiryDateTime = this.value.dateOfEnquiry ? new Date(this.value.dateOfEnquiry) : new Date(this.selectEnquiryDate)

      try {
        this.franchiseeName = this.value.franchisee
        const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
        this.classes = studentclasses.data.rows

        this.classes.filter((item) => {
          item.category = item.category ? ' ( ' + item.category + ' )' : ''
          item.name = item.name + ' ' + item.category
        })

        if (this.formType !== 'admission' && this.formType !== 'createAdmission' && this.formType !== 'createEnquiryQR') {
          const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
          this.franchiseeArr = response.data.rows
        }

        if (this.formType === 'createEnquiryQR') {
          const response = await http.get(`${constants.API_URL}/api/franchisee/get/all-active`)
          this.franchiseeArr = response.data
          this.$emit('franchiseeOpt', this.franchiseeArr)
        }

        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.obj.academicYearID = this.obj.acadmicyear = academicYear ? academicYear.id : ''
        if (this.formType === 'createEnquiryQR') {
          // Default academic year selection
          this.value.academicYearID = this.academicYears[0].id
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }

      if (this.radio2) {
        this.radio = this.radio2
      }
    },
    writableData: async function () {
      if (this.isWritable === 'false') {
        this.isReadonly = true
        this.isDisabled = true
      }

      this.cardTitle = 'Admission Details'
      this.cardIcon = 'mdi-account-details'

      if (this.formType === 'edit_registration' || this.formType === 'admission') {
        this.isRegistration = true
        this.isReadonly = true
        this.isDisabled = true
      }
    }
  }
}
</script>
